// services/config.ts
interface EnvConfig {
    apiHost: string;
    appTitle: string;
}

export function loadEnvConfig(): EnvConfig {
    const apiHost = process.env.VUE_APP_API_HOST
    const appTitle = process.env.VUE_APP_APP_TITLE

    if (!apiHost) {
        throw new Error('VUE_APP_API_HOST is not defined in environment variables')
    }

    return {
        apiHost,
        appTitle: appTitle || 'Metabase Proxy'
    }
}